/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppUserDto } from '../../models/app-user-dto';

export interface UsersUserIdGet$Plain$Params {
  userId: string;
}

export function usersUserIdGet$Plain(http: HttpClient, rootUrl: string, params: UsersUserIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AppUserDto>> {
  const rb = new RequestBuilder(rootUrl, usersUserIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppUserDto>;
    })
  );
}

usersUserIdGet$Plain.PATH = '/users/{userId}';
